import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ImportConfiguration } from "../../types/importConfiguration";
import { RootState } from "../index";

interface IInitialState {
  selectedInstance: string;
  selectedEntity: string;
  operationIdentifier: string;
  destinationIdentifier: string;
  sources: any[];
  mappings: any[];
  importConfigurations: ImportConfiguration[];
  selectedImportConfiguration: ImportConfiguration | null;
}

const initialState: IInitialState = {
  selectedInstance: "",
  selectedEntity: "",
  operationIdentifier: "",
  destinationIdentifier: "",
  sources: [],
  mappings: [],
  importConfigurations: [],
  selectedImportConfiguration: null
};

export const dataverseSlice = createSlice({
  name: "dataverse",
  initialState,
  reducers: {
    setInstance(state, action: PayloadAction<string>) {
      state.selectedInstance = action.payload;
    },
    setEntity(state, action: PayloadAction<string>) {
      state.selectedEntity = action.payload;
    },
    setOperationIdentifier(state, action: PayloadAction<string>) {
      state.operationIdentifier = action.payload;
    },
    setDestinationIdentifier(state, action: PayloadAction<string>) {
      state.destinationIdentifier = action.payload;
    },
    setImportConfigurations(state, action: PayloadAction<ImportConfiguration[]>) {
      state.sources = action.payload;
    },
    selectImportConfiguration(state, action: PayloadAction<ImportConfiguration | null>) {
      state.selectedImportConfiguration = action.payload;
    },
    clearDataverseState(state) {
      state = initialState; // Reset to initial state
    }
  },
});
export const getInstance = (state: RootState) => state.dataverse.selectedInstance;
export const getEntity = (state: RootState) => state.dataverse.selectedEntity;

export const {
  clearDataverseState,
  setInstance,
  setEntity,
  setOperationIdentifier,
  setDestinationIdentifier,
  setImportConfigurations,
  selectImportConfiguration
} = dataverseSlice.actions;
